import React from "react"
import { useHistory } from "react-router-dom"
import { useRecoilState } from "recoil"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { useSnackbar } from "notistack"
import Grid from "@material-ui/core/Grid"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import Button from "../components/Button"
import TextField from "../components/TextField"
import betaCodeExists from "../libs/betaCodeExists"
import onboardingProgress from "../store/onboardingProgress"

export default function Beta() {
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const [progress, setProgress] = useRecoilState(onboardingProgress)

  return (
    <Formik
      initialValues={{
        code: "",
      }}
      validationSchema={Yup.object().shape({
        code: Yup.string().required("Required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
        try {
          await betaCodeExists(values.code)
          resetForm({})
          setStatus({ success: true })
          enqueueSnackbar("Welcome to the beta!", {
            variant: "success",
          })
          setProgress({
            ...progress,
            betaCode: values.code,
          })
          setSubmitting(false)
          history.push("/signup/start")
        } catch (error) {
          setStatus({ success: false })
          setErrors({ code: "Code has expired or does not exist" })
          console.error("error:", error)
          setSubmitting(false)
        }
      }}
    >
      {({ errors, handleBlur, handleChange, isSubmitting, touched, values, setFieldValue }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h3>Enter Beta Invitation Code</h3>
            </Grid>
            <Grid item xs={12}>
              <TextField
                autoFocus
                error={Boolean(touched.code && errors.code)}
                helperText={touched.code && errors.code}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.code}
                label="Invitation Code"
                name="code"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} justifyContent="flex-end">
            <Grid item>
              <Button
                disabled={isSubmitting}
                endIcon={<ChevronRightIcon />}
                isLoading={isSubmitting}
                type="submit"
              >
                Get Started
              </Button>
            </Grid>
          </Grid>

          <div style={{ clear: "both", content: "", display: "block" }}></div>
        </Form>
      )}
    </Formik>
  )
}
